// extracted by mini-css-extract-plugin
export default {"trending":"Trending_trending__s8xsx","cardsContainer":"Trending_cardsContainer__C5ZC1"};